import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
    {
        path: '/products',
        name: 'ProductsView',
        component: () => import(/* webpackChunkName: "products-view" */ '@/modules/products/components/ProductsView'),
        meta: {
            moduleId: 'products',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/products/:id',
        name: 'ProductForm',
        component: () => import(/* webpackChunkName: "products-form" */ '@/modules/products/components/ProductForm'),
        meta: {
            moduleId: 'products',
            preloads: ['system/countries/default']
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/productcategories',
        name: 'ProductCategoriesView',
        component: () => import(/* webpackChunkName: "product-categories-view" */ '@/modules/product_categories/ProductCategoriesView'),
        meta: {
            moduleId: 'productCategories',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/productcategories/:id',
        name: 'ProductCategoriesForm',
        component: () => import(/* webpackChunkName: "product-categories-form" */ '@/modules/product_categories/ProductCategoriesForm'),
        meta: {
            moduleId: 'productCategories',
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/productattributes',
        name: 'ProductAttributesView',
        component: () => import(/* webpackChunkName: "product-attributes-view" */ '@/modules/product_attributes/components/ProductAttributesView'),
        meta: {
            moduleId: 'productattributes',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/productattributes/:id',
        name: 'ProductAttributesForm',
        component: () => import(/* webpackChunkName: "products-attributes-form" */ '@/modules/product_attributes/components/ProductAttributesForm'),
        meta: {
            moduleId: 'productattributes',
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
]
